import { Button, Typography } from "@suraasa/placebo-ui"
import { TooltipRenderProps } from "react-joyride"

import { IMPACT_COURSE_TOUR_TARGETS } from "./constants"

function learningTabScrollResources() {
  const navbar = document.getElementById("learning-item-navbar")
  const resourceTab = document.getElementById("learning-item-navbar-resource")

  if (!navbar || !resourceTab) {
    console.error("Navbar or resource tab not found")
    return
  }

  // Calculate the scroll position needed
  const scrollLeft = resourceTab.offsetLeft + navbar.clientWidth

  // Smooth scroll to the position
  navbar.scrollTo({
    left: scrollLeft,
    behavior: "instant",
  })
}
// const scrollToTop = () => {
//   window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
// }
const scrollToTop = (duration = 1250) => {
  const start = window.pageYOffset
  const startTime = performance.now()

  const scroll = (currentTime: number) => {
    const elapsed = currentTime - startTime
    const progress = Math.min(elapsed / duration, 1)

    // Easing function for smooth deceleration
    const easeOutCubic = 1 - Math.pow(1 - progress, 3)

    window.scrollTo(0, start * (1 - easeOutCubic))

    if (progress < 1) {
      requestAnimationFrame(scroll)
    }
  }

  requestAnimationFrame(scroll)
}

const OnboardingStep = ({
  toolTipRenderProps,
  navigate,
  finalStepFunc,
  updateStepIndex,
}: {
  toolTipRenderProps: TooltipRenderProps
  navigate: () => void
  finalStepFunc: () => void
  updateStepIndex: (index?: number | undefined) => void
}) => {
  // const navigate = useNavigate()
  const { index, size, isLastStep, step } = toolTipRenderProps

  return (
    <div className="w-full max-w-[calc(100vw_-_32px)] overflow-hidden rounded-xl bg-white p-2.5 sm:w-[345px] sm:max-w-none">
      <div>{step.content}</div>
      <div className="flex w-full items-center justify-between">
        <div className="flex w-full items-center justify-between gap-2">
          <Typography variant="preTitle" className="text-onSurface-500">
            {index + 1} OF {size}
          </Typography>
          <Button
            color="black"
            size="sm"
            className="ml-auto flex"
            onClick={() => {
              if (
                step.target
                  .toString()
                  .includes(IMPACT_COURSE_TOUR_TARGETS.learningButtonWeb) ||
                step.target
                  .toString()
                  .includes(IMPACT_COURSE_TOUR_TARGETS.learningButtonMobile)
              ) {
                navigate()
                updateStepIndex()
                return
              }
              if (
                step.target
                  .toString()
                  .includes(IMPACT_COURSE_TOUR_TARGETS.courseTour.milestoneList)
              ) {
                learningTabScrollResources()
                scrollToTop()
                updateStepIndex()
                return
              }

              if (isLastStep) {
                finalStepFunc()
                return
              }
              updateStepIndex()
            }}
          >
            {isLastStep ? "Finish Tour" : "Next"}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default OnboardingStep
